<template>
  <div class="border bg-ligth-brown">
    <ol class="d-sm-flex justify-content-around mb-0 p-sm-2">
      <li  class="EBD">
        <span>EBD</span>
        <span> - <translate>Early Booking</translate></span>
      </li>
      <li class="SPO">
        <span>SPO</span>
        <span> - <translate>Special Offer</translate></span>
      </li>
      <li class="LM">
        <span>LM</span>
        <span> - <translate>Last Minute</translate></span>
      </li>
      <li class="FC">
        <span>FC</span>
        <span> - <translate>Free Child</translate></span>
      </li>
      <li  class="FCAVL">
        <span>AVL</span>
        <span> - <translate>Available</translate></span>
      </li>
      <li  class="RQNA">
        <span>RQ</span>
        <span> - <translate>On Request</translate></span>
      </li>
      <li  class="SPOEBD">
        <span>N/A</span>
        <span> - <translate>Stop Sale</translate></span>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Legend'
}
</script>
